var map = {
	"./legend_english.png": "brKA",
	"./legend_english_dark.png": "wWt0",
	"./legend_spanish.png": "vqDR",
	"./legend_spanish_dark.png": "2K20",
	"./legend_xa_english.png": "K1wN",
	"./legend_xa_english_dark.png": "dxDs",
	"./legend_xa_english_dark_vertical.png": "PoPW",
	"./legend_xa_english_vertical.png": "67TI",
	"./legend_xa_spanish.png": "4mpf",
	"./legend_xa_spanish_dark.png": "+Q/V",
	"./legend_xa_spanish_dark_vertical.png": "UJzI",
	"./legend_xa_spanish_vertical.png": "wdY6",
	"./legend_xg_english.png": "Hec4",
	"./legend_xg_english_dark.png": "zRyM",
	"./legend_xg_english_dark_vertical.png": "cKRc",
	"./legend_xg_english_vertical.png": "6yIz",
	"./legend_xg_spanish.png": "CHjW",
	"./legend_xg_spanish_dark.png": "FOr9",
	"./legend_xg_spanish_dark_vertical.png": "gOS5",
	"./legend_xg_spanish_vertical.png": "bTCJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "y3wm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/legend_.*\.png$
// module id = y3wm
// module chunks = 79